import * as AuthToken from './AuthToken'

export const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

export const removeTokenFromUrl = () => {
    const url = new URL(window.location.href)
    url.searchParams.delete('token')
    window.history.replaceState({}, '', url.toString())
  }

export const getParamFromState = (paramName) => {
    const state = getQueryParam('state')
    if (!state)
      return null
    const data = JSON.parse(atob(state))
    return data[paramName]
  }

export const handleLogout = () => {
  AuthToken.removeAllCookies()
  window.location.reload()
}
